import { ADMIN_LIST_VIEW_FILTER_DROPDOWN } from 'src/constants/filterConstants';
import {
    SET_FILTER_DETAILS,
    GET_FILTER_DETAILS_FAILURE,
    GET_FILTER_DETAILS_SUCCESS,
    CLEAR_ADMIN_FILTERS,
} from '../action/actionTypes';

const initialState = {
    selectedFilter: {
        selectedDistrict: {},
        selectedTerritory: {},
        selectedRole: {},
        salesOrg: [],
    },
    selectedDistrict: {},
    selectedTerritory: {},
    selectedRole: {},
    district: [],
    territory: [],
    role: [],
    filterType: '',
    isFiltersCleared: false,
};

const AdminFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTER_DETAILS:
            return {
                ...state,
                filterType: action.payload.filterType,
                selectedFilter: {
                    selectedDistrict:
                        action.payload.filterType ===
                        ADMIN_LIST_VIEW_FILTER_DROPDOWN()[0].name
                            ? action.payload.filterData
                            : state.selectedFilter.selectedDistrict,
                    selectedTerritory:
                        action.payload.filterType ===
                        ADMIN_LIST_VIEW_FILTER_DROPDOWN()[1].name
                            ? action.payload.filterData
                            : state.selectedFilter.selectedTerritory,
                    selectedRole:
                        action.payload.filterType ===
                        ADMIN_LIST_VIEW_FILTER_DROPDOWN()[2].name
                            ? action.payload.filterData
                            : state.selectedFilter.selectedRole,
                    salesOrg:
                        action.payload.filterType === 'salesOrg'
                            ? action.payload.filterData
                            : state.selectedFilter.salesOrg,
                },
            };

        case GET_FILTER_DETAILS_SUCCESS:
            return {
                ...state,
                district: action.payload.district,
                territory: action.payload.territory,
                role: action.payload.role,
            };
        case GET_FILTER_DETAILS_FAILURE:
            return {
                ...state,
            };
        case CLEAR_ADMIN_FILTERS:
            return {
                ...state,
                isFiltersCleared: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default AdminFilterReducer;
